import { differenceInMinutes, differenceInHours, format } from "date-fns"

/**
 * Formats a given date as:
 * - "x minutes ago" for < 100 minutes
 * - "x hours ago" for < 24 hours
 * - "MM-dd-yyyy" for >= 24 hours
 */
export function formatRelativeTime(date: Date): string {
  const now = new Date()
  const minutesDiff = differenceInMinutes(now, date)

  if (minutesDiff < 100) {
    return `${minutesDiff} minute${minutesDiff !== 1 ? "s" : ""} ago`
  }

  const hoursDiff = differenceInHours(now, date)
  if (hoursDiff < 24) {
    return `${hoursDiff} hour${hoursDiff !== 1 ? "s" : ""} ago`
  }

  return format(date, "MM-dd-yyyy")
}
